document.addEventListener('DOMContentLoaded', function() {
    // Handle pagination clicks
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('search-results-pagination__page')) {
            e.preventDefault();
            
            // Remove active class from all pagination links
            const allPaginationLinks = document.querySelectorAll('.search-results-pagination__page');
            allPaginationLinks.forEach(function(link) {
                link.classList.remove('search-results-pagination__page--active');
            });
            
            // Add active class to clicked link
            e.target.classList.add('search-results-pagination__page--active');
            
            // Get data attributes
            const page = e.target.getAttribute('data-page');
            const searchQuery = e.target.getAttribute('data-search-query');
            const nonce = e.target.getAttribute('data-nonce');
            
            // Make AJAX call to load new results
            fetch(stcaAjax.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'load_more',
                    page: page,
                    searchQuery: searchQuery,
                    nonce: nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Update the search results content
                    document.querySelector('.search-results-block__list').innerHTML = data.data.articles;
                }
            })
            .catch(error => {
                console.log('Error loading search results:', error);
            });
        }
    });
});